<template>
     <q-page class="row q-pt-md" >
        <div class="col" style="margin-top:0; margin-right:auto; margin-bottom:0; margin-left:auto;">
        <div class="bg-white" style="border-radius: 25px 25px 0px 0px"><!-- 
        <q-card-section class="text-h6 text-primary q-pl-md titleheader">ONLINE REDEMPTION</q-card-section> -->
        <q-card-section class="text-h5 text-primary q-pl-md titleheader">
            <div class="row">
            <div class="column items-start">{{StoreStateT.OnlineTransactionAccount}} </div>
            <div class="column items-start"> - {{StoreStateT.OnlineTransactionInvestor }} </div>
             </div>
            </q-card-section>
        <div v-if="StoreStateT.OnlineTransactionsJointAccounts.length !=0 " >
            <q-card-section v-for="users in StoreStateT.OnlineTransactionsJointAccounts"   v-bind:key="users.index" class="text-h6 text-primary q-pl-md titleheader">
                <div class="row">
                    <div class=" col-2">
                        <q-icon name="fas fa-link" color="primary"/> {{users.JointCustomerName}} 
                    </div>
                </div>
            </q-card-section>
        </div>
        <q-card-section class="bg-white" style="border-radius:25px">
          <q-stepper ref="stepper" v-model="StoreStateAD.RedemptionStep"  color="primary" animated alternative-labels contractable class="no-shadow no-border-radius ">
            <q-step class="QStepHead" :done="StoreStateAD.RedemptionStep > 1" :header-nav="StoreStateAD.RedemptionStep > 1" name="1" title="Fund Cart">
                <q-form >
                   <!--  <TransactionRedemptionPRS v-if="StoreStateT.OnlineTransactionPlan=='PRS'"></TransactionRedemptionPRS>
                    <TransactionRedemptionUT v-if="StoreStateT.OnlineTransactionPlan=='CS'||StoreStateT.OnlineTransactionPlan=='EPF'"></TransactionRedemptionUT> -->
                    <Redemption  
                        :appId=appId
                        :customerId=customerId
                        :accountId=accountId
                        :scheme=scheme
                        :transactionType=transactionType
                        :plan=plan
                        :currency=currency
                        :withdrawalReason=withdrawalReason	
                        :isSophisticatedInvestor=isSophisticatedInvestor
				       	:channel=channel
				        :userId=userId
                        @submit="submit"
                        @cancel="cancel"
                    />
                </q-form>
            </q-step>
            <q-step class="QStepHead" :done="StoreStateAD.RedemptionStep > 2" :header-nav="StoreStateAD.RedemptionStep > 2" name="2" title="TAC Verification">
                <q-form class="q-gutter-md">
                    <TransactionSummary></TransactionSummary>
                    <DeclarationCheckbox 
                          ref="DCB"
                          class="q-pa-md"
                          @Agreed="AgreeOnDeclaration()"
                        />
                    <TAC></TAC>
                    <Notice></Notice>
                </q-form>
            </q-step>
            <q-step class="QStepHead" :done="StoreStateAD.RedemptionStep > 3" :header-nav="StoreStateAD.RedemptionStep >3" name="3" title="Complete">
                <q-form class="q-gutter-md ">
                   	<Acknowledgement
                        class="ackForm"
                        :TC_TransactionStatus=StoreStateAD.TC_TransactionStatus
                        :TC_Reason=StoreStateAD.TC_Reason 
                        :InvestorName=StoreStateAD.InvestorName
                        :ReferenceID=StoreStateCD.FormDetails.ApplicationFormId
                        :AccountNo=StoreStateT.OnlineTransactionAccount
                        :AccountType=StoreStateT.OnlineTransactionType
                        :TrxType=trx
                        :Transaction=StoreStateCD.Transaction
                        @print="print"
                    />
                </q-form>
            </q-step>
        </q-stepper>
        </q-card-section>
        </div>
        </div>

          <q-dialog v-model="StoreStateT.OnlineTransactionAlert"  persistent transition-show="scale" transition-hide="scale">
                <q-card style="width:700px;max-width:80vw">
                <q-card-section>
                    Hi There!
                </q-card-section>
                  <q-card-section>
                      <div class="row">
                          <div class="col">
                              Please key in your mobile number for TAC purpose; if not the TAC will be send to investor's registered mobile number
                          </div>
                          <div class="col">
                              <q-input
                                    filled
                                    v-model="StoreStateAO.ContactInformation.MobileNo"
                                    label="Phone"
                                    mask="##########"
                                    hint="Mask: ##########"
                                />
                          </div>
                      </div>
                </q-card-section>
                <q-card-section>
                     <Navigation
                        class="q-px-sm"
                        :ShowConfirmButton=true
                        ConfirmButtonColor="primary"
                        @ConfirmButton="Confirmed()"
                    />
                </q-card-section>
                </q-card>
           </q-dialog>
     
        <q-dialog v-model="cancelMsg" persistent transition-show="scale" transition-hide="scale">
    
        
            <q-card  style="width:600px;max-width:80vw">
            <q-card-section class="bg-red text-white">
                <div class="text-h4">Notification</div>
            </q-card-section>

            <q-separator ></q-separator>

            <q-card-actions >
                <div class="text-h5">
                {{msg}}
                </div>
            </q-card-actions>
            </q-card>
     
      
        </q-dialog>

     </q-page>
    
</template>

<style>
.redemptionTxt{
    color: #2f56e2 !important;
    font-weight: 600;

}
</style>

<script>
import store from '../../../store';
import axios from 'axios'
/* import TransactionRedemptionPRS from '@/components/online/redemption/TransactionRedemptionPRS'
import TransactionRedemptionUT from '@/components/online/redemption/TransactionRedemptionUT' */
import { date } from 'quasar';
import { mapActions } from 'vuex'

import Redemption from '../../../components/redemption/Redemption.vue';
import Acknowledgement from '../../../components/acknowledgement/acknowledgement.vue';

import Navigation from '@/components/NavigationButtons'

import Notice from '@/components/online/Notice.vue'
import TAC from '@/components/online/TAC.vue'
import DeclarationCheckbox from '@/components/online/Declaration.vue'
import TransactionSummary from '@/components/online/redemption/TransactionSummary.vue'
export default {
  name: 'TransactionsRedemptionPRS',
  components: {
    /* TransactionRedemptionPRS,
    TransactionRedemptionUT, */
    Notice,
    TAC,
    Navigation,
    DeclarationCheckbox,
    TransactionSummary,
    Acknowledgement,
    Redemption
  },
  data () {
    return {
        StoreStateCD : store.state.CD,
        StoreStateAD: store.state.AD,
        StoreStateT: store.state.Transactions,
        StoreStateAO : store.state.AOD,
        cancelMsg: false,
        msg:'',

       	/* TC_TransactionStatus:'0000', // 0000 if success, any other code for failure
        TC_Reason:'Processing.', // depending on the message you want to show
        InvestorName:'Mohan',
        ReferenceID:'1231ldsald-12321lnsadnla-12312naskjd-12313',
        AccountNo:'123123213',
        AccountType:'Conventional' , */

        Data : '',
        TransactionId : '',
        tempMobileNo:'',
        appId: store.state.Transactions.OnlineTransactionappId,//'pkQkFqPYHd3azmey_QVCVQ',
        customerId:   store.state.Transactions.OnlineTransactionUserID,  //'851215075401',
        accountId: store.state.Transactions.OnlineTransactionAccount, //'0019506',
        scheme: store.state.Transactions.OnlineTransactionScheme,//'PRSG',
        userId:   store.state.Transactions.OnlineTransactionUserID,
        transactionType:  store.state.Transactions.OnlineTransactionType,//'PRS', //PRS or UTF
        plan: store.state.Transactions.OnlineTransactionPlan,//'PRS', //  PRS or EPF or CASH
        currency: store.state.Transactions.OnlineTransactionCurrency, 
        withdrawalReason: store.state.Transactions.OnlineTransactionWithdrawalReason,
        channel : 'IAccess',
        trx:"Online Redemption",
        /* agentId: '', */
        isSophisticatedInvestor: true,
        base64String:''
    }
  },
  methods : {
    
    ...mapActions([
        "GetLookup",
        "RequestTAC",
        "getTransactionCart",
        "GetListOfFundBuy",
        "getDocumentDownloadLink",
        "PostOnlineRedemptionTransaction",
        "TrnxCifCustomerAccountInfo",
        "sendAckEmail"
        ]),
        cancel:function(){
            
            this.cancelMsg = true
               /*  this.$q.dialog({
                    title: 'Warning',
                    message: 'Transaction Cancelled, you may navigate by selecting options on the left tab',
                    ok:false,
                    cancel: false,
                    persistent: true
                }) */
           //  window.location.href = 'http://192.168.10.229/OneHopLink/modules/customers/new-account-dash#/account?id='+this.StoreStateT.OnlineTransactionIaccessUserID+'&b=1'
        },
        submit: function(payload) { 
          //  console.log(payload)
             this.$q.loading.show({
                spinnerSize: 50,
            })

                this.PostOnlineRedemptionTransaction({
                    ApplicationId : this.StoreStateT.OnlineTransactionappId,
                    AccountType: this.StoreStateT.OnlineTransactionPlan,
                    Channel:'IAccess',
                    CustomerID: this.StoreStateT.OnlineTransactionUserID ,
                    AccountId : this.StoreStateT.OnlineTransactionAccount,
                    Content : payload
                })
                .then(res=>{
                if(res === true){
                this.getTransactionCart({
                    ApplicationId: this.StoreStateCD.FormDetails.ApplicationId
                }).then(res=>{
                    if(res == true){
                        
                        var today = new Date();
                        var dd = today.getDate();

                        var mm = today.getMonth()+1; 
                        var yyyy = today.getFullYear();
                        if(dd<10) 
                        {
                            dd='0'+dd;
                        } 

                        if(mm<10) 
                        {
                            mm='0'+mm;
                        } 

                        today = yyyy+'-'+mm+'-'+dd

                        if(this.StoreStateCD.Transaction.Redemption.length>0){
                            var FundCode = ''
                            for(var i=0; i<this.StoreStateCD.Transaction.Redemption.length; i++){
                                FundCode = this.StoreStateCD.Transaction.Redemption[i].FundCode
                                var vm = this;
                                this.getDocumentDownloadLink({
                                    AsOfDate:today,
                                    FundCode:FundCode
                                })  
                                .then(res=>{
                                    
                                    if(res!=false){  
                                      //  console.log(res)
                                        for(var a=0; a<vm.StoreStateCD.Transaction.Redemption.length; a++){
                                            vm.StoreStateCD.Transaction.Redemption[a].doclink = res.toString()
                                        }
                                    }

                                })   

                            }
                        }
                        
                        this.$q.loading.hide()
                        this.StoreStateAD.RedemptionStep='2'
                    }else{
                        
                        this.$q.loading.hide()
                        this.$q.dialog({
                            title : 'Warning',
                            message : res
                        })
                    }
                    }) 
                }
                }) 
            
              
        },
     /*    back: function(payload) { 
            this.msg = 'Transaction Cancelled, you may navigate by selecting options on the left tab'
            this.cancelMsg = true
        
        }, */
        print:function (obj){
            console.log(obj)

            var PrintObjt= obj;
            var trxDateTime = PrintObjt.trxDateTime
            let TYPED_ARRAY = new Uint8Array(PrintObjt.obj.data);
            const STRING_CHAR = TYPED_ARRAY.reduce((data, byte)=> {
                    return data + String.fromCharCode(byte);
            }, '')
            this.base64String = btoa(STRING_CHAR); 

           // console.log(this.base64String)
                this.sendAckEmail({
                   base64String : this.base64String,
                   trxDateTime : trxDateTime
                })
        },

     
        Confirmed:function(){
            
            this.StoreStateT.OnlineTransactionAlert = false
        },

          AgreeOnDeclaration(){
            if(this.$refs.DCB.Agree === true){
                this.$emit('AgreeOnDeclaration')
                this.StoreStateT.showButton2 = true;



               /*  this.formatMobileNo();
                this.RequestTAC({
                    CustomerTelMobile : this.StoreStateAO.ContactInformation.MobileNo,
                    Purpose : 'I-Access Fund Transaction',
                    CustomerId : this.StoreStateT.OnlineTransactionUserID,
                    RIDType : ''
                })
                .then(res=>{
                    if(res===true){  
                         this.StoreStateT.showButton = true;
                        this.$q.dialog({
                            title : 'Message',
                            message : 'A TAC has been sent to your mobile no ' + this.tempMobileNo
                        })
                    }
                }) */

            }
            else{
                 this.StoreStateT.showButton = false;
                this.StoreStateT.showButton2 = false;
                this.$emit('DisagreeOnDeclaration')
            }
        },

        formatMobileNo:function() {
        var mobileNo = this.StoreStateAO.ContactInformation.MobileNo          
        this.tempMobileNo =  '01x- xxxx ' + mobileNo.slice(-4) ;
      },
  },
  mounted(){
      
    this.msg = 'Transaction closed, you may navigate by selecting options on the left tab'
    this.cancelMsg = false;

   this.$q.loading.show()
    this.GetLookup().then(res=>{
        if(res===true){
            
            this.GetListOfFundBuy().then(res=>{
                if(res===true){
                    this.TrnxCifCustomerAccountInfo().then(res=>{
                        if(res===true){

                            this.$q.loading.hide()
                        }else{

                            alert(res)
                            this.$q.loading.hide()
                        }
                    })
                }else{
                    alert(res)
                    this.$q.loading.hide()
                }
            })

        }else{
            alert(res)
            this.$q.loading.hide()
        }
    })
    //this.Data = this.$route.params.data
  }

 
}
</script>
<style scoped>
  .q-card__section--vert{
          padding: 1px !important;
  }

</style>
